import React, { MouseEvent, DragEvent } from 'react'
import cx from 'classnames'
import styles from './Card.module.scss'
import Image from '../Image'
import Button from '../Button'

type CardProps = {
    img?: {
        src: string
        alt: string
    }
    title?: string
    children: React.ReactNode | React.ReactNode[]
    classes?: string
    innerClasses?: string
    onClick?: (e: MouseEvent<HTMLDivElement>) => void
    draggable?: boolean
    onDrag?: (e: DragEvent<HTMLDivElement>) => void
    actions?: {
        title: string
        onAction: () => void
        type?: 'primary' | 'secondary' | 'tertiary'
        classes?: string
    }[]
    hoverEffect?: boolean
    style?: React.CSSProperties
}

const Card: React.FC<CardProps> = ({
    classes,
    innerClasses,
    title,
    img,
    children,
    onClick,
    draggable = false,
    onDrag,
    actions,
    hoverEffect = false,
    style = undefined,
}) => {
    const onClickEventHandler = (e: MouseEvent<HTMLDivElement>) => {
        if (onClick !== undefined) onClick(e)
    }

    const onDragEventHandler = (e: DragEvent<HTMLDivElement>) => {
        if (onDrag !== undefined) onDrag(e)
    }

    return (
        <div
            className={cx(
                hoverEffect ? styles['zr-card-hover'] : styles['zr-card'],
                classes
            )}
            draggable={draggable}
            style={style}
            onDrag={(event) => onDragEventHandler(event)}
        >
            <div onClick={(event) => onClickEventHandler(event)} className={'zr-w-100'}>
                {img && <Image src={img.src} alt={img.alt} width={'100%'} />}
                <div className={cx(styles['zr-card-inner'], innerClasses)}>
                    {title && (
                        <p className={cx(styles['zr-card-title'])}>{title}</p>
                    )}
                    {children}
                </div>
            </div>
            {actions && actions.length > 0 && (
                <div className={cx(styles['zr-card-actions'])}>
                    {actions.map((action, index) => {
                        return (
                            <Button
                                key={index}
                                hierarchy={action.type ?? 'primary'}
                                text={action.title}
                                type={'button'}
                                classes={action.classes}
                                fn={action.onAction}
                            />
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default Card
